import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from './config';
import { BRAND_NAME, BRAND_TAGLINE } from './brand';

const SiteSettingsContext = createContext({ settings: {}, loaded: false });

const DEFAULTS = {
    site_name: BRAND_NAME,
    site_tagline: BRAND_TAGLINE,
    contact_phone: '+91-22-6100-4000',
    contact_whatsapp: '+91-99887-66554',
    contact_email: 'hello@zirconestates.com',
    contact_address: 'DLF Cyber City, Gurgaon, Haryana 122002',
    working_hours: 'Mon – Sat: 9am – 7pm IST',
    cin: 'U70200MH2024PTC428712',
    rera_agent_reg: 'A52000123456',
    founding_year: '',
    transactions_count: '',
    builder_partners_count: '',
    about_og_image_url: '',
    about_brokerage_fee_answer: '',
    leadership_team: '',
    facebook_url: '#',
    instagram_url: '#',
    linkedin_url: '#',
    youtube_url: '#',
    twitter_url: '#',
};

export function SiteSettingsProvider({ children }) {
    const [settings, setSettings] = useState(DEFAULTS);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const url = `${API_BASE}/site-settings`;
        axios.get(url)
            .then(r => {
                const data = (r.data && typeof r.data === 'object' && !Array.isArray(r.data)) ? r.data : {};
                setSettings({ ...DEFAULTS, ...data });
            })
            .catch(() => {})
            .finally(() => setLoaded(true));
    }, []);

    return (
        <SiteSettingsContext.Provider value={{ settings, loaded }}>
            {children}
        </SiteSettingsContext.Provider>
    );
}

export function useSiteSettings() {
    return useContext(SiteSettingsContext);
}

// Helper for WhatsApp link
export function waLink(phone) {
    if (!phone) return '#';
    return `https://wa.me/${phone.replace(/[^\d]/g, '')}`;
}

export function telLink(phone) {
    if (!phone) return '#';
    return `tel:${phone.replace(/\s/g, '')}`;
}
